import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Paper, Button, Chip, Alert, Divider,
} from '@mui/material';
import axios from '../api/axios';

const VERSIONS = [
  { kind: 'windows', file: 'inventory_agent.exe', title: 'Windows 7 / 8 / 10 / 11',
    note: '32-битный .exe с окном настройки. Подходит и для 32-, и для 64-битных систем.' },
  { kind: 'xp', file: 'inventory_agent_xp.exe', title: 'Windows XP / Vista',
    note: 'Отдельная лёгкая сборка для старых систем (сбор через wmic, без PowerShell).' },
  { kind: 'source', file: 'inventory_agent.py', title: 'Linux / исходник (.py)',
    note: 'Запуск системным python3: «python3 inventory_agent.py --gui» или «--install».' },
];

export default function AgentDownload() {
  const [avail, setAvail] = useState({});

  useEffect(() => {
    axios.get('/agent/download').then((r) => setAvail(r.data || {})).catch(() => {});
  }, []);

  const download = async (kind, file) => {
    try {
      const r = await axios.get(`/agent/download/${kind}`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = file; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { /* ignore */ }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 900 }}>
      <Typography variant="h5" sx={{ mb: 1 }}>Скачать агент</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Агент собирает с компьютера инвентарь (железо/ПО), живые метрики, сетевую активность
        и состояние безопасности и шлёт в систему. Один файл — это и окно настройки, и сама служба.
      </Typography>

      <Alert severity="info" sx={{ mb: 2 }}>
        <b>Как пользоваться:</b> скачайте файл для нужной ОС → запустите → вставьте адрес сервера и
        токен устройства (берётся в карточке устройства → «Агент» → «Подключить агент») →
        «Проверить связь» → «Установить службу». Дальше данные идут сами.
      </Alert>

      {VERSIONS.map((v) => (
        <Paper key={v.kind} variant="outlined" sx={{ p: 2, mb: 1.5, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Box sx={{ flexGrow: 1, minWidth: 260 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{v.title}</Typography>
              {avail[v.kind] === false && <Chip size="small" color="warning" variant="outlined" label="нет на сервере" />}
            </Box>
            <Typography variant="body2" color="text.secondary">{v.note}</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>{v.file}</Typography>
          </Box>
          <Button variant="contained" disabled={avail[v.kind] === false}
                  onClick={() => download(v.kind, v.file)}>
            Скачать
          </Button>
        </Paper>
      ))}

      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Первичное сканирование без сервера</Typography>
      <Typography variant="body2" color="text.secondary">
        Запустите агент, нажмите <b>«Сканировать в файл»</b> — он соберёт инвентарь ПК в файл.
        Затем в системе: «Устройства» → <b>«Из скана»</b> (создать новое устройство) или в карточке
        существующего устройства → <b>«Загрузить скан»</b> (обновить его данными скана).
      </Typography>
    </Box>
  );
}
